import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import ListIcon from "../../../media/images/ListIcon.mjs";
import AppCpeCveIcon from "../../../media/app-images/AppCpeCveIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, Form, Input, InputGroup, InputGroupText, Label, Progress} from "reactstrap";
import MySelect from "../../../controls/MySelect/MySelect.mjs";
import "./CveList.css";
import PagedNavigation from "../../../ComponentParts/PagedNavigation/PagedNavigation.mjs";
import MetricInfoModal from "../../../ComponentParts/CVE/MetricInfoModal.mjs";
import AppDownloadIcon from "../../../media/app-images/AppDownloadIcon.mjs";

const prefix = "CveList";

const pageSizes = [10,25,50,100,250,500].map( x => ({label: String(x), value: x }));

const CveList = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			by: Glob.getPageParam('by'),
			selectedYear: Glob.getPageParam('year') ? Number(Glob.getPageParam('year')) : false,
			ll: Glob.getLanguageLong(),
			pageSize: props.pageSize || 25,
		}
		this.uid = Glob.generateUid(prefix);
		this.fetch = this.fetch.bind(this);
		this.fetchYears = this.fetchYears.bind(this);
		this.sortBy = this.sortBy.bind(this);
		this.sort = this.sort.bind(this);
		this.autoSort = this.autoSort.bind(this);
		this.downloadData = this.downloadData.bind(this);
	}
	componentDidMount() {
		Glob.setStatus('pageTitle', ['CVE','Available CVEs']);
		Glob.setStatus('pageIcon', <AppCpeCveIcon />);
		Glob.register('currentPage', this.autoSort, this.uid);
		Glob.register('Prefs', () => {
			const ll = Glob.getLanguageLong();
			if (ll !== this.state.ll) this.setState({ll: ll});
		}, this.uid);
		setTimeout(this.fetchYears);
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	fetchYears() {
		appLib.api('cve/status').then( x => {
			const o = (x?.list||[]).map( y =>({
					value: y.year,
					label: `${y.year} (${y.cve.toLocaleString(this.state.ll)})`
				}));
			this.setState({ years: o });
		}).catch( err => {
			console.log(err);
			setTimeout( this.fetchYears, 3000);
		});
	}
	fetch() {
		if ( this.state.loadedYear && this.state.loadedYear === this.state.selectedYear ) return;
		this.setState({ data: null, range: null, loading: true, loadedYear: false }, ()=>{
			Glob.rmCurrentPageParam('page');
			Glob.rmCurrentPageParam('by');
			if ( ! this.state.selectedYear ) {
				this.setState({ loading: false });
				return;
			}
			appLib.api('cve/list-by-year', { year: this.state.selectedYear, verbose: true }).then( x => {
				const l = ( x?.list||[]).map( c =>{
					c.number = parseInt( c.id.split('-').pop() );
					c.searchable = [c.id,c.title||'',c.desc||'']
						.join(' ')
						.toLocaleLowerCase(this.state.ll)
						.replace(/[^a-z0-9-]+/g,' ')
						.trim();
					return c;
				});
				this.setState({ data: l, loadedYear: this.state.selectedYear }, this.sort );
			}).catch( err => {
				this.setState({ loading: false });
				console.log(err);
			});
		});
	}
	autoSort(cp) {
		if (!cp) cp = Glob.getCurrentPage();
		const ns = {};
		const year = cp.params.year ? Number(cp.params.year) : false;
		if ( year !== this.state.selectedYear ) {
			this.setState({ selectedYear: year }, this.fetch );
			return;
		}
		if (cp.params.by !== this.state.by) ns.by = cp.params.by;
		if (cp.params.pageSize && parseInt(cp.params.pageSize) !== this.state.pageSize) ns.pageSize = parseInt(cp.params.pageSize);
		if (cp.params.filter !== this.state.filter) ns.filter = cp.params.filter;
		this.setState(ns, this.sort);
	}
	sortBy(axle) {
		if (axle === 'name') axle = undefined;
		if (axle === this.state.by) return;
		if (axle) {
			Glob.setCurrentPageParam('by', axle);
		} else {
			Glob.rmCurrentPageParam('by');
		}
		Glob.rmCurrentPageParam('page');
	}
	sort() {
		if (!this.state.data) return;
		const by = this.state.by || 'name';
		const currentPage = (() => {
			const c = Glob.getPageParam('page');
			if (c && !isNaN(Number(c))) return parseInt(c);
			return 1;
		})();
		let page = currentPage;
		let range = structuredClone(this.state.data || []);
		if (this.state.filter) {
			const f = this.state.filter.toLocaleLowerCase(this.state.ll).replace(/[^a-z0-9-]+/g,' ').trim();
			range = range.filter(x => x.searchable.includes(f));
		}
		const totEntries = range.length;
		const pages = Math.ceil(totEntries / this.state.pageSize);
		range.sort((a, b) => (a.number - b.number) );
		switch (this.state.by) {
			case 'description':
				range.sort((a, b) => (a.title ?? a.desc ?? '').toLocaleLowerCase(this.state.ll).localeCompare((b.title?? b.desc ?? '').toLocaleLowerCase(this.state.ll)));
				break;
			case 'score':
				range.sort((a, b) => ( b.baseScore - a.baseScore ));
				break;
			default:
				break;
		}
		if ((page - 1) * this.state.pageSize > range.length) page = 1;
		range = range.slice((page - 1) * this.state.pageSize, page * this.state.pageSize);
		this.setState(
			{
				range: range,
				by: by,
				page: String(page),
				pages: pages,
				totFound: totEntries,
				loading: false,
			},
			() => {
				if (page !== currentPage) Glob.setCurrentPageParam('page', String(page));
			}
		);
	}
	downloadData() {
		const list = this.state.data.map( x => {
			delete x.searchable;
			delete x.number;
			return x;
		});
		const data = {
			date: new Date(),
			year: this.state.selectedYear,
			CVEs: list.length,
			list: list
		}
		Glob.saveJSON(data, `horus-loaded-cve-${this.state.loadedYear}.json`);
	}
	render() {
		if ( ! this.state.years ) return null;
		return (
			<SliderPanel
				icon={ <ListIcon /> }
				title={<TextLabel value={"Available CVEs"} /> }
				className={prefix}
			>
				<div className={"panel-content limited"}>
					<Form className={"pt-1"}>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Year"} />:
								</Label>
							</InputGroupText>
							<div style={{minWidth:"180px"}}>
								<MySelect
									placeholder={ Glob.label("Select") }
									isClearable={true}
									isDisabled={ this.state.loading}
									options={ this.state.years }
									onChange={ o => {
										if ( o?.value ) {
											Glob.setCurrentPageParam('year', o.value);
										} else {
											Glob.rmCurrentPageParam('year');
										}
									}}
								/>
							</div>
							<Button
								color={"success"}
								hidden={ ! (this.state.loadedYear ) }
								onClick={ this.downloadData }
							>
								<TextLabel value={"Download"} /> <AppDownloadIcon />
							</Button>
							<InputGroupText hidden={! this.state.range}>
								<Label>
									<TextLabel value={"Page size"} />:
								</Label>
							</InputGroupText>
							<div style={{minWidth:"110px"}} hidden={! this.state.range}>
								<MySelect
									options={ pageSizes }
									value={ pageSizes.find( o => o.value === this.state.pageSize ) }
									onChange={ o => this.setState({ pageSize: o.value }, this.sort )}
								/>
							</div>
						</InputGroup>
					</Form>
					{ ( !! this.state.loading ) && (
						<div className={"m-4"}>
							<Progress striped animated value={100} />
						</div>
					)}
					{ ( this.state.range && ! this.state.loading) && (
						<div className={"data-container"}>
							<Form
								className={"filter"}
								onSubmit={ e => { e.preventDefault(); }}
							>
								<InputGroup>
									<InputGroupText>
										<Label>
											<TextLabel value={"Filter"} />:
										</Label>
									</InputGroupText>
									<Input
										type="text"
										autoFocus={true}
										value={this.state.filter || ''}
										onChange={e => {
											this.setState({filter: e.target.value}, this.sort);
										}}
									/>
									<InputGroupText className={"tot"}>
										{ this.state.totFound ? <tt>{this.state.totFound.toLocaleString(this.state.ll)}</tt> : <span/> }
									</InputGroupText>
								</InputGroup>
							</Form>
							{ this.state.range.length > 0 && (
								<>
									<PagedNavigation pages={ this.state.pages } />
									<table className={"cves-list"} cellSpacing={0} cellPadding={0} border={0}>
										<thead>
										<tr>
											<th
												role={"button"}
												onClick={() => {
													this.sortBy('name')
												}}
												className={this.state.by === 'name' ? 'active' : ''}
											>
										<span>
											<TextLabel value={"CVE"}/>
										</span>
											</th>
											<th
												role={"button"}
												onClick={()=>{
													this.sortBy('score')
												}}
												className={this.state.by === 'score' ? 'active' : ''}
											>
										<span>
											<TextLabel value={"Severity"}/>
										</span>
											</th>
											<th
												role={"button"}
												onClick={() => {
													this.sortBy('description')
												}}
												className={this.state.by === 'description' ? 'active' : 'no-mobile'}
											>
												<span> <TextLabel value={"Description"}/> </span>
											</th>
										</tr>
										</thead>
										<tbody>
										{this.state.range.map((cve) => (
											<tr
												key={cve.id}
												onClick={ ()=>{ this.setState({metricsInfo: cve }) }}
											>
												<td>
													{(cve.name ?? cve.id ?? '').replace(/^cve-/i,'')}
												</td>
												<td className={"severity "+(cve.baseSeverity||'')}>
													<span>{ cve.baseSeverity ?? (cve.baseScore||0).toLocaleString(this.state.ll) }</span>
													<span>{ (cve.baseScore||0).toLocaleString(this.state.ll) }</span>
												</td>
												<td className={"no-mobile desc"}>
													{cve.title ?? cve.desc ?? ''}
												</td>
											</tr>
										))}
										</tbody>
									</table>
								</>
							) }
							{ (!! this.state.metricsInfo) && (
								<MetricInfoModal
									cve={ this.state.metricsInfo.id }
									metric={ this.state.metricsInfo }
									close={ ()=>{ this.setState({metricsInfo: null}) }}
								/>
							)}
						</div>
					)}
				</div>
			</SliderPanel>
		)
	}
}

export default CveList;